import { loadStripe } from '@stripe/stripe-js';

/**
 * Shared Stripe.js instance for the whole frontend.
 *
 * The publishable key comes from REACT_APP_STRIPE_PUBLISHABLE_KEY (set in
 * frontend/.env and inlined at build time). Publishable keys are safe to
 * ship in client code. Never put the secret key (sk_*) here.
 */
const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!publishableKey) {
  // Surface misconfiguration loudly during development/build instead of
  // silently failing card tokenization at checkout time.
  console.error(
    'Missing REACT_APP_STRIPE_PUBLISHABLE_KEY — set it in frontend/.env and rebuild.'
  );
}

export const stripePromise = loadStripe(publishableKey || '');
